import { render, staticRenderFns } from "./GerenciamentoModulos.vue?vue&type=template&id=b53d7846"
import script from "./GerenciamentoModulos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports